import React from 'react';
import './Lightbox.css'; // Add CSS for styling

const LightBox = ({ files, currentIndex, onClose, onNext, onPrev }) => {
    if (files.length === 0) return null;

    const file = files[currentIndex];
    const isImage = file.type.startsWith('image/');

    return (
        <div className="lightbox-overlay" onClick={onClose}>
            <div className="lightbox-content" onClick={e => e.stopPropagation()}>
                <button className="lightbox-close" onClick={onClose}>X</button>
                {isImage ? (
                    <img src={URL.createObjectURL(file)} alt="Lightbox" className="lightbox-image" />
                ) : (
                    <video src={URL.createObjectURL(file)} controls className="lightbox-video" />
                )}
                <button className="lightbox-prev" onClick={onPrev}>&lt;</button>
                <button className="lightbox-next" onClick={onNext}>&gt;</button>
            </div>
        </div>
    );
};

export default LightBox;
